import { pickDefaultAgencyNode } from '../model/agency-settings-selection'

/**
 * Agency-settings panel seam. Exposes the pure default-node selection decider so
 * the panel's fetch handler reaches it without value-importing `model/` (the
 * MVVM no-restricted-imports rule on model/).
 */
export function useAgencySettingsSelection() {
  return { pickDefaultAgencyNode }
}
